import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './DashboardViewer.css';

function DashboardViewer({ user, onLogout }) {
  const { name } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  
  // Forza HTTPS usando window.location.protocol
  const protocol = window.location.protocol; // 'https:' o 'http:'
  const host = window.location.host; // 'www.communityproekinex.com'
  const dashboardUrl = `${protocol}//${host}/dashboard/${name}/index.php`;

  useEffect(() => {
    console.log('📊 DashboardViewer mounted');
    console.log('📝 Dashboard name:', name);
    console.log('🔗 Dashboard URL:', dashboardUrl);
    
    setTimeout(() => setLoading(false), 300);
  }, [name, dashboardUrl]);

  function handleBack() {
    navigate('/tools/dashboards');
  }

  return (
    <div className="dashboard-viewer">
      <div className="viewer-header">
        <button className="back-button" onClick={handleBack}>
          ← Torna alle Dashboard
        </button>
        <h2>{name.replace('dashboard_', '').replace(/_/g, ' ')}</h2>
        <button className="logout-button" onClick={onLogout}>
          Logout
        </button>
      </div>
      
      {loading ? (
        <div className="loading-container">
          <p>Caricamento dashboard...</p>
        </div>
      ) : (
        <iframe
          src={dashboardUrl}
          title={`Dashboard ${name}`}
          className="dashboard-iframe"
          sandbox="allow-scripts allow-same-origin allow-forms"
        />
      )}
    </div>
  );
}

export default DashboardViewer;
